export const HEADER_SEARCH_CLOSE_EVENT = "cc-header-search-close";

/** Close header search overlay and reset query (ShopHeader listens). */
export function dispatchHeaderSearchClose(): void {
  if(typeof window === "undefined") return;
  window.dispatchEvent(new Event(HEADER_SEARCH_CLOSE_EVENT));
}
